module.exports = __webpack_public_path__ + "assets/images/boundaries/details/smc.svg?v=3e3d2f46";